import React from "react";

/** Tool Badge logo mark. The PNG has a built-in black square background with orange glyph. */
export function LogoMark({ size = 64, pulse = false, className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="Tool Badge"
      className={`shrink-0 rounded-xl ${pulse ? "logo-pulse" : ""} ${className}`}
      style={{
        width: size,
        height: size,
        objectFit: "cover",
      }}
    />
  );
}

/** Plain image logo. */
export function Logo({ size = 64, className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="Tool Badge"
      className={className}
      style={{ width: size, height: size, objectFit: "cover" }}
    />
  );
}
